import { AuthenticationContext } from 'react-adal';

export const authContext = new AuthenticationContext({
    instance: 'https://login.microsoftonline.com/',
    tenant: 'common',
    clientId: '52410e5c-a891-40a0-a0a8-25aa7ededc55',
    endpoints: {
        api: 'https://johnverbiest.be/Dop.Rapporten'
    },
    postLogoutRedirectUri: 'https://www.google.be',
    redirectUri: window.location.origin,
    cacheLocation: 'sessionStorage'
});

// Default token refresh buffer time in milliseconds (5 minutes)
const TOKEN_REFRESH_BUFFER_TIME = 5 * 60 * 1000;

// Keep track of the refresh timer
let tokenRefreshTimer: number | null = null;

export const getToken = () => {
    // Get the token
    const token = authContext.getCachedToken(authContext.config.clientId);
    
    // If we have a token, set up automatic refresh
    if (token) {
        setupTokenRefresh();
    }

    return token;
};

// Function to handle token expiration
export const handleTokenExpiration = () => {
    // Clear token cache
    authContext.clearCache();
    
    // Clear any pending refresh timer
    if (tokenRefreshTimer !== null) {
        window.clearTimeout(tokenRefreshTimer);
        tokenRefreshTimer = null;
    }
    
    // Re-authenticate the user
    authContext.login();
};

// Check if a response indicates an expired token
export const isTokenExpired = (statusCode: number): boolean => {
    // 401 Unauthorized typically indicates expired token
    return statusCode === 401;
};

// Setup automatic token refresh before expiration
const setupTokenRefresh = () => {
    // Clear any existing timer
    if (tokenRefreshTimer !== null) {
        window.clearTimeout(tokenRefreshTimer);
        tokenRefreshTimer = null;
    }
    
    try {
        const token = authContext.getCachedToken(authContext.config.clientId);
        if (!token) return;
        
        // Decode the JWT token to get expiration time
        const tokenPayload = parseJwt(token);
        
        if (tokenPayload && tokenPayload.exp) {
            // exp is in seconds since epoch
            const expirationTime = tokenPayload.exp * 1000; // convert to milliseconds
            const currentTime = Date.now();
            
            // Calculate time until token refresh (expiration time minus buffer)
            const timeUntilRefresh = expirationTime - currentTime - TOKEN_REFRESH_BUFFER_TIME;
            
            // If token is already close to expiration or expired, refresh now
            if (timeUntilRefresh <= 0) {
                console.log('Token is about to expire or has expired, refreshing now...');
                refreshToken();
            } else {
                // Set timer to refresh token before it expires
                console.log(`Setting token refresh timer for ${Math.round(timeUntilRefresh / 1000 / 60)} minutes from now`);
                tokenRefreshTimer = window.setTimeout(() => {
                    refreshToken();
                }, timeUntilRefresh);
            }
        }
    } catch (error) {
        console.error('Error setting up token refresh:', error);
    }
};

// Refresh the token
const refreshToken = () => {
    console.log('Refreshing token...');
    authContext.acquireToken(authContext.config.clientId, (error, token) => {
        if (error || !token) {
            console.error('Error refreshing token, will redirect to login:', error);
            handleTokenExpiration();
        } else {
            console.log('Token refreshed successfully');
            // Setup the next refresh
            setupTokenRefresh();
        }
    });
};

// Helper function to parse JWT token
const parseJwt = (token: string) => {
    try {
        // Get the payload part of the JWT (second part)
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
        );
        return JSON.parse(jsonPayload);
    } catch (error) {
        console.error('Error parsing JWT:', error);
        return null;
    }
};
